import { render } from "./AdvertisingMaterial.vue?vue&type=template&id=3b25a2b1&scoped=true"
import script from "./AdvertisingMaterial.vue?vue&type=script&lang=js"
export * from "./AdvertisingMaterial.vue?vue&type=script&lang=js"

import "./AdvertisingMaterial.vue?vue&type=style&index=0&id=3b25a2b1&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b25a2b1"]])

export default __exports__